module.exports = __webpack_public_path__ + "img/qz5.0.b590850a.jpg";